import React, { useEffect, useRef } from "react";

const GoogleStreetView = ({ lat, lng }) => {
  const streetViewRef = useRef(null);
  useEffect(() => {
    if (!window.google || !lat || !lng) return;

    new window.google.maps.StreetViewPanorama(streetViewRef.current, {
      position: { lat, lng },
      pov: { heading: 165, pitch: 0 },
      zoom: 1,
    });
  }, [lat, lng]); 

  return <div ref={streetViewRef} style={{ width: "100%", height: "500px" }} />;
};

export default GoogleStreetView;
